import { useState } from "react";

const Subscribe = ({ onFormSubmit }) => {
    const [mail, setMail] = useState('');
    const [isValid, setIsValid] = useState(true);
    const [isEmpty, setIsEmpty] = useState(true);

    
    const validate = (e) => {
        const emailValue = e.target.value;
        setMail(emailValue);
        setIsEmpty(emailValue === '');

        const emailRegex = /^([a-z\d.%+-]+)@([a-z\d]+)\.([a-z]{2,8})$/;

        const isValidInput = emailRegex.test(emailValue);
        setIsValid(isValidInput);

    }

    const handleSubmit = (e) => {
        e.preventDefault();
       if(isValid && !isEmpty) {
        onFormSubmit(mail);
       }
    }
    
    return ( 
        <div className="form-container">
            <form  onSubmit={ handleSubmit }>
                <label>Email address <span className={ isValid ? "hidden-text" : "show-text" } >please enter a valid email </span></label>
                <input
                type="email"
                placeholder="email@company.com"
                name="mail"
                value={ mail }
                onChange={validate} />
                <button type="submit">Subscribe to monthly newsletter</button>
            </form>

        </div>
        
     );
}
 
export default Subscribe;